import type { ComponentCommonDays } from '@edwin-group/cj-graphql/generated/graphql';
import { getDaySuffix } from './get-day-suffix';

export const formatDate = (day: ComponentCommonDays) => {
  const startDate = new Date(day.startDate);
  const startDay = getDaySuffix(startDate.getDate());
  const startMonth = startDate.toLocaleString('en-US', { month: 'short' });

  if (day.wholeMonth) {
    return 'Whole Month';
  }

  if (day.endDate) {
    const endDate = new Date(day.endDate);
    const endDay = getDaySuffix(endDate.getDate());
    const endMonth = endDate.toLocaleString('en-US', { month: 'short' });

    return `${startMonth} ${startDay} - ${endMonth} ${endDay}`;
  }

  return `${startMonth} ${startDay}`;
};
